import type { SupabaseClient } from '@supabase/supabase-js';

let client: Promise<SupabaseClient> | null = null;

/**
 * Loads supabase-js on first use, so it never weighs on the initial bundle (and is never
 * fetched at all in the dev bypass). Only the public URL and anon key are used.
 */
export function loadSupabase(url: string, anonKey: string): Promise<SupabaseClient> {
  if (!url || !anonKey) {
    return Promise.reject(
      new Error('Sign-in is not configured: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'),
    );
  }
  client ??= import('@supabase/supabase-js').then(({ createClient }) =>
    createClient(url, anonKey, {
      auth: {
        flowType: 'pkce',
        detectSessionInUrl: true,
        persistSession: true,
        autoRefreshToken: true,
      },
    }),
  );
  return client;
}
